import axios from './axios';
import SETTINGS from '../settings'
export default {
    getInitiatives(cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/initiative?_embed=1&`).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    }
}